import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";

type RequirePermissionProps = {
  permission: string;
  redirectTo: string;
  children: ReactNode;
};

/**
 * Route guard that renders children only when the current user holds the
 * named permission. Mirrors the RequireFlag route guard's shape so the two
 * can be composed on the same route (flag AND permission).
 * When the permission is missing, redirects to the provided fallback route.
 */
export default function RequirePermission({
  permission,
  redirectTo,
  children,
}: RequirePermissionProps) {
  const { hasPermission } = usePermissions();

  if (!hasPermission(permission)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
